module.exports = __webpack_public_path__ + "img/look14.c8cd7a6c.png";